import { Vue, Prop, Component } from 'vue-property-decorator';
import FeatureVersionValidator from '@/components/feature-version-validator/feature-version-validator-logic';
import { TableData, TableRowObject, TableCellInfo, TableCssClassesObject } from 'components';

@Component({
	mounted() {
		this.tableClasses = Object.assign({}, this.tableClasses, this.$props.cssClasses);
	},

	components: {
		'feature-version-validator': FeatureVersionValidator
	}
})
export default class Table extends Vue {
	@Prop({
		default() {
			return {
				cols: <Array<TableCellInfo>>[],
				rows: <Array<Array<TableCellInfo> | TableRowObject>>[],
				cellSizes: <Array<string>>[]
			};
		}
	})
	tableData!: TableData;

	@Prop({
		default() {
			return {};
		}
	})
	cssClasses!: object;

	tableClasses: TableCssClassesObject = {
		rowBody: 'table__row-body',
		table: 'table full_width',
		cellSize: 'cell_m'
	};

	getRowData(row: TableRowObject) {
		return Array.isArray(row) ? row : row.data;
	}

	getCellSize(item: TableCellInfo, index: number) {
		return typeof item === 'string' || !this.tableData.cellSizes ? this.tableClasses.cellSize : this.tableData.cellSizes[index];
	}

	getDataLabel(item: TableCellInfo) {
		return typeof item === 'string' ? item : item.text;
	}

	isLastRow(index: number, colsCount: number) {
		return index === colsCount - 1;
	}
}
